import { css } from 'styled-system/css';

export const mobileNavigationStyles = {
	container: css({
		display: 'flex',
		flexDir: 'column',
		justifyContent: 'space-between',
	}),
	item: css({
		cursor: 'pointer',
		bgColor: 'jupiter.grey.10',
		h: '54px',
		p: '12px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		color: 'jupiter.grey.70',
		'& .icon': {
			color: 'jupiter.grey.60',
			w: '16px',
			h: '16px',
		}
	}),
	bottomText: css({
		position: 'fixed',
		bottom: '0',
		left: 0, 
		right: 0,
		fontSize: '12px',
		fontWeight: '500',
		lineHeight: '15px',
		color: 'jupiter.grey.60',
		textAlign: 'center',
		p: '24px',
		
	})
}